import { message } from 'antd';
import { getBackendUri } from '../utils/EnvConfigUtils';
import FetchUtils, { parseJSON } from './fetch_utils';
import { nullSafeGet } from '../utils/DataAccessUtils';
import { WORK_ORDER_PRIORITIES_CRUD_ACTION_CREATORS } from '../actions/work_order_priorities_actions';
import RestCrudThunks from './restCrudThunksGenerator';
import { AREAS_CRUD_ACTION_CREATORS } from '../actions/areas_actions';
import { LOCATIONS_CRUD_ACTION_CREATORS } from '../actions/locations_actions';
import { WORK_ORDERS_CRUD_ACTION_CREATORS } from '../actions/work_orders_actions';
import { ASSETS_CRUD_ACTION_CREATORS } from '../actions/assets_actions';
import { PROBLEM_TYPES_CRUD_ACTION_CREATORS } from '../actions/problem_types_actions';
import { WORK_ORDER_ATTRIBUTES_CRUD_ACTION_CREATORS } from '../actions/work_order_attributes_actions';
import { TROUBLESHOOTING_CRUD_ACTION_CREATORS } from '../actions/troubleshooting_actions';
import { TROUBLESHOOTING_ANSWERS_CRUD_ACTION_CREATORS } from '../actions/troubleshooting_answer_actions';
import { clearCachedUserDetails } from './session_thunks';
import { COMPANY_CONFIG_CRUD_ACTION_CREATORS } from '../actions/company_config_actions';
import { CONTRACTOR_CLIENTS_CRUD_ACTION_CREATORS } from '../actions/contractor_clients_actions';
import { CONTRACTOR_LOCATIONS_CRUD_ACTION_CREATORS } from '../actions/contractor_locations_actions';
import { CONTRACTOR_PROBLEM_TYPES_CRUD_ACTION_CREATORS } from '../actions/contractor_problem_types_actions';
import { CONTRACTOR_WO_PRIORITIES_CRUD_ACTION_CREATORS } from '../actions/contractor_wo_priorities_actions';

const fetchUtils = new FetchUtils();

export const autorizeRequestPortal =
	(roleType) =>
	({ customerId, locationId, areaId, problemTypeId }) => {
		const baseUrl = getBackendUri();
		const apiUrl = `/api/portal/request-portal/validate/${customerId}${
			locationId ? '/location/' + locationId : ''
		}${areaId ? '/area/' + areaId : ''}${problemTypeId ? '/problemType/' + problemTypeId : ''}`;

		// if sorting present, fix order naming and add to query params

		return (dispatch) => {
			return new Promise((resolve, reject) => {
				fetchUtils
					.post(
						baseUrl + apiUrl,
						Object.assign({
							headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
						})
					)
					.then(parseJSON)
					.then(({ json, status, ok }) => {
						const d = json;
						if (status === 401 && localStorage.getItem('token')) {
							dispatch(clearCachedUserDetails());
						}
						if (status !== 200) {
							reject(d.message);
							message.error(d.data);
						} else {
							resolve(d.data);
							localStorage.setItem('token', nullSafeGet('data.token', d));
							dispatch(getCompanyConfigRequestPortal(nullSafeGet('data.buyerCompanyId', d)));
						}
					})
					.catch((d) => {
						reject(d.message);
					});
			});
		};
	};
export const autorizeClientRequestPortal =
	(roleType) =>
	({ customerId, locationId, areaId, problemTypeId, clientId }) => {
		const baseUrl = getBackendUri();
		const apiUrl = `/api/portal/client-portal/validate/${customerId}/client/${clientId}${
			locationId ? '/location/' + locationId : ''
		}${areaId ? '/area/' + areaId : ''}${problemTypeId ? '/problemType/' + problemTypeId : ''}`;

		// if sorting present, fix order naming and add to query params

		return (dispatch) => {
			return new Promise((resolve, reject) => {
				fetchUtils
					.post(
						baseUrl + apiUrl,
						Object.assign({
							headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
						})
					)
					.then(parseJSON)
					.then(({ json, status, ok }) => {
						const d = json;
						if (status === 401 && localStorage.getItem('token')) {
							dispatch(clearCachedUserDetails());
						}
						if (status !== 200) {
							reject(d.message);
							message.error(d.data);
						} else {
							resolve(d.data);
							localStorage.setItem('token', nullSafeGet('data.token', d));
							// dispatch(getCompanyConfigRequestPortal(nullSafeGet('data.buyerCompanyId', d)));
						}
					})
					.catch((d) => {
						reject(d.message);
					});
			});
		};
	};

export const getCompanyConfigRequestPortal = (companyId, params = {}) => {
	const baseUrl = getBackendUri();
	const apiUrl = `/api/portal/buyer_company_settings/${companyId}`;

	return (dispatch) => {
		return new Promise((resolve, reject) => {
			fetchUtils
				.get(
					baseUrl + apiUrl,
					Object.assign(
						{ headers: { Accept: 'application/json', 'Content-Type': 'application/json' } },
						params
					)
				)
				.then(parseJSON)
				.then(({ json, status, ok }) => {
					const d = json;
					if (status === 401 && localStorage.getItem('token')) {
						dispatch(clearCachedUserDetails());
					}
					if (status !== 200) {
						reject(d.message);
						message.error(d.data);
					} else {
						dispatch(COMPANY_CONFIG_CRUD_ACTION_CREATORS.fetchOneSuccess(d.data));
						resolve(d.data);
					}
				})
				.catch((d) => {
					reject(d.message);
				});
		});
	};
};

export const workOrderPrioritiesRestCrudThunksForCustomer = new RestCrudThunks(
	'work_order_priorities',
	'work_order_priority',
	'workOrderPriority',
	'workOrderPriorities',
	WORK_ORDER_PRIORITIES_CRUD_ACTION_CREATORS,
	null,
	'',
	false,
	'work_order/',
	'/api/portal'
);
export const workOrderPrioritiesRestCrudThunksForClient = new RestCrudThunks(
	'contractor_work_order_priorities',
	'work_order_priority',
	'workOrderPriority',
	'workOrderPriorities',
	CONTRACTOR_WO_PRIORITIES_CRUD_ACTION_CREATORS,
	null,
	'',
	false,
	'work_order/',
	'/api/portal'
);

export const areasRestCrudThunksForCustomer = new RestCrudThunks(
	'areas',
	'area',
	'area',
	'areas',
	AREAS_CRUD_ACTION_CREATORS,
	null,
	'',
	false,
	'location/',
	'/api/portal'
);

export const areasTopLevel =
	(roleType) =>
	(
		params,
		targetCollectionName = null,
		pagination = null,
		sorting = null,
		filters = null,
		addToTargetCollection = false
	) => {
		// if pagination present, transform into limit/offset format and add to query params
		const baseUrl = getBackendUri();
		const apiUrl = `/api/portal/location/areas/top_level`;
		if (pagination) {
			const paginationQuery = {
				offset: (pagination.current - 1) * pagination.pageSize,
				limit: pagination.pageSize,
			};
			params = {
				...params,
				...paginationQuery,
			};
		}

		// if sorting present, fix order naming and add to query params
		if (sorting) {
			const sortingQuery = { ...sorting, order: sorting.order === 'ascend' ? 'asc' : 'desc' };
			params = {
				...params,
				...sortingQuery,
			};
		}

		if (filters) {
			params = {
				...params,
				...filters,
			};
		}

		return (dispatch) => {
			return new Promise((resolve, reject) => {
				dispatch(AREAS_CRUD_ACTION_CREATORS.fetchStart(targetCollectionName));

				fetchUtils
					.get(
						baseUrl + apiUrl,
						Object.assign(
							{ headers: { Accept: 'application/json', 'Content-Type': 'application/json' } },
							params
						)
					)
					.then(parseJSON)
					.then(({ json, status, ok }) => {
						const d = json;

						if (d.status === 'error') {
							dispatch(AREAS_CRUD_ACTION_CREATORS.fetchError(d.message, d.data));
							reject(d.message);
						} else {
							dispatch(
								AREAS_CRUD_ACTION_CREATORS.fetchSuccess(
									d.data,
									d.count,
									targetCollectionName,
									{
										...pagination,
										total: d.count,
									},
									sorting,
									filters,
									addToTargetCollection
								)
							);
							resolve(d.data);
						}
					})
					.catch((d) => {
						dispatch(AREAS_CRUD_ACTION_CREATORS.fetchError(d.message, d.data));
						reject(d.message);
					});
			});
		};
	};

export const areasTopLevelForCustomer = areasTopLevel('buyer');

export const locationsRestCrudThunksForCustomer = new RestCrudThunks(
	'locations',
	'location',
	'location',
	'locations',
	LOCATIONS_CRUD_ACTION_CREATORS,
	null,
	'',
	false,
	'location/',
	'/api/portal'
);
export const locationsRestCrudThunksForClient = new RestCrudThunks(
	'contractor_locations',
	'location',
	'location',
	'locations',
	CONTRACTOR_LOCATIONS_CRUD_ACTION_CREATORS,
	null,
	'',
	false,
	'location/',
	'/api/portal'
);

export const workOrdersRestCrudThunksForCustomer = new RestCrudThunks(
	'work_orders',
	'work_order',
	'workOrder',
	'workOrders',
	WORK_ORDERS_CRUD_ACTION_CREATORS,
	null,
	'',
	false,
	'work_order/',
	'/api/portal'
);
export const assetsRestCrudThunksForCustomer = new RestCrudThunks(
	'assets',
	'asset',
	'asset',
	'assets',
	ASSETS_CRUD_ACTION_CREATORS,
	null,
	'',
	false,
	'asset/',
	'/api/portal'
);

export const problemTypesRestCrudThunksForCustomer = new RestCrudThunks(
	'problem_types',
	'problem_type',
	'problemType',
	'problemTypes',
	PROBLEM_TYPES_CRUD_ACTION_CREATORS,
	null,
	'',
	false,
	'work_order/',
	'/api/portal'
);
export const problemTypesRestCrudThunksForClient = new RestCrudThunks(
	'contractor_problem_types',
	'problem_type',
	'problemType',
	'problemTypes',
	CONTRACTOR_PROBLEM_TYPES_CRUD_ACTION_CREATORS,
	null,
	'',
	false,
	'work_order/',
	'/api/portal'
);
export const problemTypesTopLevel =
	(roleType) =>
	(
		params,
		targetCollectionName = null,
		pagination = null,
		sorting = null,
		filters = null,
		addToTargetCollection = false
	) => {
		// if pagination present, transform into limit/offset format and add to query params
		const baseUrl = getBackendUri();
		const apiUrl = `/api/portal/work_order/problem_types/top_level`;
		if (pagination) {
			const paginationQuery = {
				offset: (pagination.current - 1) * pagination.pageSize,
				limit: pagination.pageSize,
			};
			params = {
				...params,
				...paginationQuery,
			};
		}

		// if sorting present, fix order naming and add to query params
		if (sorting) {
			const sortingQuery = { ...sorting, order: sorting.order === 'ascend' ? 'asc' : 'desc' };
			params = {
				...params,
				...sortingQuery,
			};
		}

		if (filters) {
			params = {
				...params,
				...filters,
			};
		}

		return (dispatch) => {
			return new Promise((resolve, reject) => {
				dispatch(PROBLEM_TYPES_CRUD_ACTION_CREATORS.fetchStart(targetCollectionName));

				fetchUtils
					.get(
						baseUrl + apiUrl,
						Object.assign(
							{ headers: { Accept: 'application/json', 'Content-Type': 'application/json' } },
							params
						)
					)
					.then(parseJSON)
					.then(({ json, status, ok }) => {
						const d = json;
						if (d.status === 'error') {
							dispatch(PROBLEM_TYPES_CRUD_ACTION_CREATORS.fetchError(d.message, d.data));
							reject(d.message);
						} else {
							dispatch(
								PROBLEM_TYPES_CRUD_ACTION_CREATORS.fetchSuccess(
									d.data,
									d.count,
									targetCollectionName,
									{
										...pagination,
										total: d.count,
									},
									sorting,
									filters,
									addToTargetCollection
								)
							);
							resolve(d.data);
						}
					})
					.catch((d) => {
						dispatch(PROBLEM_TYPES_CRUD_ACTION_CREATORS.fetchError(d.message, d.data));
						reject(d.message);
					});
			});
		};
	};

export const problemTypesTopLevelForClient = (
	params,
	targetCollectionName = null,
	pagination = null,
	sorting = null,
	filters = null,
	addToTargetCollection = false
) => {
	// if pagination present, transform into limit/offset format and add to query params
	const baseUrl = getBackendUri();
	const apiUrl = `/api/portal/work_order/contractor_problem_types/top_level`;
	if (pagination) {
		const paginationQuery = {
			offset: (pagination.current - 1) * pagination.pageSize,
			limit: pagination.pageSize,
		};
		params = {
			...params,
			...paginationQuery,
		};
	}

	// if sorting present, fix order naming and add to query params
	if (sorting) {
		const sortingQuery = { ...sorting, order: sorting.order === 'ascend' ? 'asc' : 'desc' };
		params = {
			...params,
			...sortingQuery,
		};
	}

	if (filters) {
		params = {
			...params,
			...filters,
		};
	}

	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(CONTRACTOR_PROBLEM_TYPES_CRUD_ACTION_CREATORS.fetchStart(targetCollectionName));

			fetchUtils
				.get(
					baseUrl + apiUrl,
					Object.assign(
						{ headers: { Accept: 'application/json', 'Content-Type': 'application/json' } },
						params
					)
				)
				.then(parseJSON)
				.then(({ json, status, ok }) => {
					const d = json;
					if (d.status === 'error') {
						dispatch(CONTRACTOR_PROBLEM_TYPES_CRUD_ACTION_CREATORS.fetchError(d.message, d.data));
						reject(d.message);
					} else {
						dispatch(
							CONTRACTOR_PROBLEM_TYPES_CRUD_ACTION_CREATORS.fetchSuccess(
								d.data,
								d.count,
								targetCollectionName,
								{
									...pagination,
									total: d.count,
								},
								sorting,
								filters,
								addToTargetCollection
							)
						);
						resolve(d.data);
					}
				})
				.catch((d) => {
					dispatch(CONTRACTOR_PROBLEM_TYPES_CRUD_ACTION_CREATORS.fetchError(d.message, d.data));
					reject(d.message);
				});
		});
	};
};
export const problemTypesTopLevelForCustomer = problemTypesTopLevel('buyer');

export const workOrderAttributesRestCrudThunksForCustomer = new RestCrudThunks(
	'work_order_attributes',
	'work_order_attribute',
	'workOrderAttribute',
	'workOrderAttributes',
	WORK_ORDER_ATTRIBUTES_CRUD_ACTION_CREATORS,
	null,
	'',
	false,
	'spend_category/',
	'/api/portal'
);

export const troubleshootingRestCrudThunksForCustomer = new RestCrudThunks(
	'work_order_troubleshooting',
	'work_order_troubleshooting',
	'troubleshotting',
	'troubleshotting',
	TROUBLESHOOTING_CRUD_ACTION_CREATORS,
	null,
	'',
	false,
	'troubleshooting/',
	'/api/portal'
);

export const troubleshootingAnswersRestCrudThunksForCustomer = new RestCrudThunks(
	'work_order_troubleshooting_answers',
	'work_order_troubleshooting_answer',
	'troubleshottingAnswer',
	'troubleshottingAnswers',
	TROUBLESHOOTING_ANSWERS_CRUD_ACTION_CREATORS,
	null,
	'',
	false,
	'troubleshooting/',
	'/api/portal'
);

export const contractorClientsRestCrudThunksForClient = new RestCrudThunks(
	'clients',
	'client',
	'client',
	'clients',
	CONTRACTOR_CLIENTS_CRUD_ACTION_CREATORS,
	null,
	'',
	false,
	'contractor/',
	'/api/portal'
);
